import { events as eventTypes } from '../../../proto/protobuf';

import { loadProtobuf } from './lazyExports';

type GetProtobufSearchSource = (isTeamsSearch?: boolean) => Promise<eventTypes.SearchBeginV1.SearchboxSource>;
export const getProtobufSearchSource: GetProtobufSearchSource = async (isTeamsSearch) => {
  const { events } = await loadProtobuf();

  const SearchboxSource = events.SearchBeginV1.SearchboxSource;

  if (isTeamsSearch) {
    return SearchboxSource.TEAMS;
  }

  return SearchboxSource.VIVAENGAGE;
};
